import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    isCollapsed: false,
};

const globalDataSlice = createSlice({
    name:'globalData',
    initialState,
    reducers: {
        onChangeCollapsed: (state,action)=>{
            state.isCollapsed = action.payload
        }
    }
})

export const {onChangeCollapsed} = globalDataSlice.actions;
export default globalDataSlice.reducer